<script>
export default {
  computed: {
    blogs() {
      return this.siteData?.blog || []
    },
    cols() {
      if (this.$vuetify.breakpoint.smAndUp) return 2

      return 1;
    }

  }
}
</script>

<template>
  <section id="blog" style="background-color: #f4f4f8;">
    <v-container :fluid="isMiniPc">
      <h1 class="text-center font-weight-light display-2 mb-10">Duyurular</h1>
      <v-carousel hide-delimiters :min-height="400" :height="$vuetify.breakpoint.smAndDown ? 550 : 400" show-arrows-on-hover>
        <template v-for="(item, index) in blogs">
          <v-carousel-item v-if="(index + 1) % cols === 1 || cols === 1">
            <v-row class="flex-nowrap align-center justify-center">
              <template v-for="(n,i) in cols">
                <template v-if="(+index + i) < blogs.length">
                  <v-col :key="i">
                    <v-card class="blog-card" min-height="350">
                      <div class="image-container d-flex align-center mr-4" style="background: #f4f7f5;">
                        <v-img :src="blogs[+index + i].image" max-width="300" contain />
                      </div>
                      <div class="details">
                        <div>
                          <h2 class="mb-3 orange--text">{{ blogs[+index + i].title }}</h2>
                          <div class="content-area" v-html="blogs[+index + i].content"></div>
                        </div>
                        <v-btn color="app-orange" dark rounded :to="{ name: 'BlogPage', params: {slug: blogs[+index+i].slug}  }">
                          Devamını Oku
                        </v-btn>
                      </div>
                    </v-card>
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-carousel-item>
        </template>
      </v-carousel>
    </v-container>
  </section>
</template>

<style lang="scss">
.blog-card {
  display: flex !important;
  align-items: stretch !important;
  .details {
    flex:1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    .content-area {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4; /* number of lines to show */
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
}
@media screen and (max-width: 600px) {
	.blog-card {
		flex-direction: column;
		height: auto !important;
		.image-container {
			display: flex;
			justify-content: center;
			margin: 0 !important;
			.v-image {
				max-width: 100% !important;
				height: auto !important;
			}
		}
	}
}
</style>